import React, { Component } from "react";
import LocalizedStrings from "react-localization";
import en from "../../localization/localization-en.json";

let strings = new LocalizedStrings({ en });
class ProfileMenu extends Component {
  state = { showYAYScore: false };
  render() {
    var style = {};
    if (this.props.openMenu === false) {
      style = { right: "-220px" };
    }
    return (
      <div className="profile_menu">
        <div className="menu" style={style}>
          <div className="menu_button pt-4" onClick={this.props.handlerEdit}>
            {strings.edit_profile}
          </div>
          <div
            className="menu_button"
            onClick={this.props.handlerUpdatePassword}
          >
            {strings.update_password}
          </div>
          <div
            className="menu_button"
            onClick={this.props.handlerGoToBookmarks}
          >
            {strings.bookmarks}
          </div>
          <div className="menu_button" onClick={this.props.handlerYaystackText}>
            {strings.yaystack_text}
          </div>
          <div className="menu_button" onClick={this.props.handlerInviteFriend}>
            {strings.invite_friends}
          </div>
          <div className="menu_button" onClick={this.props.handlerYayScore}>
            {strings.yayscore}
          </div>
          <div className="menu_button" onClick={this.props.handlerLogout}>
            {strings.log_out}
          </div>
        </div>
        {this.renderRightSide()}
      </div>
    );
  }

  renderRightSide() {
    if (this.props.openMenu === true) {
      return (
        <div className="right_side" onClick={this.props.handlerOpenMenu} />
      );
    }
  }
}

export default ProfileMenu;



// WEBPACK FOOTER //
// ./src/components/profile/profile_menu.jsx